module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pgInner matchEdit"
  }, [_c('div', {
    staticClass: "headBar"
  }, [_vm._v("申报匹配结果")]), _vm._v(" "), _c('div', {
    staticClass: "pgbody",
    style: ('height:' + _vm.pageH + 'px;')
  }, [_c('div', {
    staticClass: "rowsLine clearfix"
  }, [_c('div', {
    staticClass: "iTerm"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("发布者")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_vm._v(_vm._s(_vm.itemDat.userName))])]), _vm._v(" "), _c('div', {
    staticClass: "iTerm"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("所属企业")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_vm._v(_vm._s(_vm.itemDat.enterpriseName))])]), _vm._v(" "), _c('div', {
    staticClass: "iTerm"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("发布时间")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_vm._v(_vm._s(_vm.itemDat.updatedAt))])])]), _vm._v(" "), _c('div', {
    staticClass: "rowsLine clearfix"
  }, [_c('div', {
    staticClass: "iTerm"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("产业方向")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_vm._v(_vm._s(_vm.itemDat.policyTypeIdName))])]), _vm._v(" "), _c('div', {
    staticClass: "iTerm"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("企业类型")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_vm._v(_vm._s(_vm.itemDat.subjectTypeName))])])]), _vm._v(" "), _c('div', {
    staticClass: "rowsLine clearfix"
  }, [_c('div', {
    staticClass: "iTerm"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("近一年营业收入")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_vm._v("\n                      " + _vm._s(_vm.itemDat.operatingIncome) + "\n                   ")])]), _vm._v(" "), _c('div', {
    staticClass: "iTerm"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("近一年企业利润")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_vm._v("\n                      " + _vm._s(_vm.itemDat.corporateProfits) + "\n                   ")])]), _vm._v(" "), _c('div', {
    staticClass: "iTerm"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("近一年研发经费")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_vm._v("\n                      " + _vm._s(_vm.itemDat.technologyFunding) + "\n                   ")])])]), _vm._v(" "), _c('div', {
    staticClass: "rowsLine clearfix"
  }, [_c('div', {
    staticClass: "iTerm"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("人员规模")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_vm._v("\n                      " + _vm._s(_vm.itemDat.numberOfParticipantsName) + "\n                   ")])]), _vm._v(" "), _c('div', {
    staticClass: "iTerm"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("知识产权")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_vm._v("\n                      " + _vm._s(_vm.itemDat.intellectualPropertyName) + "\n                   ")])]), _vm._v(" "), _c('div', {
    staticClass: "iTerm"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("发明专利")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_vm._v("\n                      " + _vm._s(_vm.itemDat.patentName) + "\n                   ")])])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%",
      "margin-top": "60px"
    },
    attrs: {
      "data": _vm.pocList,
      "header-row-class-name": "tableHead"
    },
    on: {
      "selection-change": _vm.tabSelect
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "policyTypeIdName",
      "label": "申报标题"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "policyTypeIdName",
      "width": "180",
      "align": "center",
      "label": "政策分类"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-footer"
  }, [(_vm.allPages > 1) ? _c('el-pagination', {
    staticClass: "paging",
    attrs: {
      "current-page": _vm.listParams.no,
      "page-count": _vm.allPages,
      "layout": "total, prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "footBlock"
  }, [_c('el-button', {
    attrs: {
      "size": "medium"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-5aef5bda"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Enterprise/userMent/matchView.vue
// module id = 1499
// module chunks = 1